import { useTranslation } from 'react-i18next';
import { Result, Button } from 'antd';

import s from './PageStates.module.scss';

import type { FC } from 'react';

interface IErrorStateProps {
  onRetry: () => void;
}

const ErrorState: FC<IErrorStateProps> = ({ onRetry }) => {
  const { t } = useTranslation();

  return (
    <div className={s['state-container']} data-cy="error-state">
      <Result
        status="error"
        title={t('tasksDashboard.errorState.title')}
        subTitle={t('tasksDashboard.errorState.description')}
        extra={
          <Button type="primary" onClick={onRetry} data-cy="retry-button">
            {t('tasksDashboard.errorState.retry')}
          </Button>
        }
      />
    </div>
  );
};

export default ErrorState;
